<template>
  <div class="info-widget-component">
    <div class="btn-hover-times">
      <b-button
        class="btn__icon btn__icon--primary px-1 py-0"
        @click="$emit('hideItemLayout')"
      >
        <i
          class="fal fa-times"
          aria-hidden="true"
        />
      </b-button>
    </div>
    <div
      v-if="preloader"
      class="d-flex flex-column align-items-center"
    >
      <div class="preloader preloader-header-box" />
      <div class="preloader preloader-text-box" />
    </div>
    <div v-if="!preloader">
      <div
        v-if="!item.disabled"
        class="item-header d-flex justify-content-center align-items-center"
      >
        <b-button
          class="button-transparent"
          @click="infoWidgetLink(item.widgetLink,item.widgetOption)"
        >
          <i
            :class="`${item.icon} mr-2`"
            aria-hidden="true"
          />
          <span>{{ count }}</span>
        </b-button>
      </div>
      <div
        v-if="item.disabled"
        class="item-text d-flex justify-content-center align-items-center text-center mt-4"
      >
        <span>{{ $tc('dashboard.widget.widgetNotAvailable') }}</span>
      </div>
      <div
        v-if="!item.disabled"
        class="item-text d-flex justify-content-center align-items-center text-center"
      >
        <span>{{ $tc(item.label) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import dashboardService from '@/api/resources/dashboard/dashboardService'
import { DashboardWidgetOption } from '@/modules/dashboardModule/dashboard-view.model'
import { PromiseUtils } from '@/shared/util/promise-utils'

export default {
    name: 'InfoWidget',
    props: {
        item: { type: Object },
        laboratoryId: { type: Number }
    },
    data() {
        return {
            count: null,
            preloader: false
        }
    },
    async mounted() {
        this.count = await this._getWidgetCount(this.item.widgetOption, this.laboratoryId)
    },
    methods: {
        async _getWidgetCount(widgetOption, laboratoryId) {
            switch (widgetOption) {
            case DashboardWidgetOption.REQUESTS_WITH_AP_REPORT_NOT_SEEN:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfUnseenRequests())
            case DashboardWidgetOption.LOCKED_REQUESTS:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfLockedRequests())
            case DashboardWidgetOption.REGISTRY_TODAY:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfRegisteredTodayCases(laboratoryId))
            case DashboardWidgetOption.REGISTRY_REQUESTED:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfRequestedRequests(laboratoryId))
            case DashboardWidgetOption.REGISTRY_REQUESTS_LOCKED:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfRegistryLockedRequests(laboratoryId))
            case DashboardWidgetOption.PORTION_CUT:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfPortionsPendingCut(laboratoryId))
            case DashboardWidgetOption.PORTION_MAKE:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfPortionsPendingMake(laboratoryId))
            case DashboardWidgetOption.SUBPORTION_TO_SCANNER:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfSubPortionsPendingScan(laboratoryId))
            case DashboardWidgetOption.WASTE_TODAY:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfSamplesDisposedToday(laboratoryId))
            case DashboardWidgetOption.PENDING_DISPOSAL:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfSamplesPendingDisposal(laboratoryId))
            case DashboardWidgetOption.OPENED_INCIDENTS:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfOpenIncidentsByLoggedInUser(laboratoryId))
            case DashboardWidgetOption.FOR_GROSSING:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfSamplesPendingProcessing(laboratoryId))
            case DashboardWidgetOption.FOR_REGROSSING:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfSamplesPendingReProcessing(laboratoryId))
            case DashboardWidgetOption.GROSSING_TODAY:
                return PromiseUtils.toCallSecure(dashboardService.getSummaryOfProcessedTodaySamples(laboratoryId))
            }
        },
        infoWidgetLink(link, option) {
            this.$router.push({ name: link, params: { sidebarOption: option } })
        }
    }
}
</script>

<style lang="scss">
    .info-widget-component .preloader {
        opacity: .3;
    }
    .info-widget-component .preloader-header-box {
        width: 60px;
        height: 30px;
    }
    .info-widget-component .preloader-text-box {
        width: 110px;
        height: 20px;
        margin-top: 5px;
    }
</style>
